module.exports = __webpack_public_path__ + "img/bank.d01fc8ac.svg";